import { render, staticRenderFns } from "./ApproversData.vue?vue&type=template&id=7c2e003c&scoped=true&"
import script from "./ApproversData.vue?vue&type=script&lang=ts&"
export * from "./ApproversData.vue?vue&type=script&lang=ts&"
import style0 from "./ApproversData.vue?vue&type=style&index=0&id=7c2e003c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e003c",
  null
  
)

export default component.exports